import React, {useContext} from 'react';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import PlainComment from '@src/components/CommentsList/PlainComment/PlainComment';
import RenderIf from '@src/components/RenderIf/RenderIf';
import Translate from '@src/components/Translate/Translate';
import trans from '@src/helpers/trans';
import {LocaleContext} from '@src/contexts/LocaleContext';
import {getUserName} from '@src/components/CommentsList/InlineUserRepresentation';

export default function ReplyToMessage(props: {
    message: ICommentModel | undefined | null,
    onCancelButtonClick?: () => void,
    hideCancelButton?: boolean,
}) {
    const {
        message,
        hideCancelButton = props.onCancelButtonClick == null,
        onCancelButtonClick
    } = props;

    const {locale} = useContext(LocaleContext);

    if (!message) {
        return null;
    }

    return <div className="chat__reply-to-message">
        <div className="chat__reply-to-message__icon">
            <i className="fa fa-reply"/>
        </div>

        <div className="chat__reply-to-message__message">
            <Translate
                    tag="div"
                    message="Chat:MessageReceiver.reply-to"
                    replace={{
                        'user-name': getUserName(message.creator, true),
                    }}
                    className="chat__reply-to-message__message__author"
            />
            <PlainComment
                    comment={message}
                    attachmentsContainerCLassName="chat__reply-to-message__message__attaches"
            />
        </div>

        <RenderIf expression={!hideCancelButton && props.onCancelButtonClick != null}>
            <button
                    type="button"
                    className="chat__reply-to-message__cancel-button"
                    onClick={onCancelButtonClick}
                    disabled={hideCancelButton}
                    title={trans('Chat:MessageReceiver.cancel-replaying-button-title', locale)}
            >
                <i className="fa fa-times"/>
            </button>
        </RenderIf>
    </div>;
}
